import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Loader, EmptyState } from "@/components/shared";
import * as Icons from "lucide-react";
import { motion } from "framer-motion";

export default function Replays() {
  const navigate = useNavigate();
  const { data, isLoading } = useQuery({ queryKey: ["sessions"], queryFn: async () => (await api.get("/sessions")).data });
  if (isLoading) return <Loader />;
  const withReplay = (data || []).filter((s) => s.replay_url);

  return (
    <div className="space-y-6" data-testid="replays-page">
      <div>
        <h1 className="font-head text-4xl text-csh-blue">Replays 🎬</h1>
        <p className="text-muted-foreground">Missed a class? Catch up and earn Story Points!</p>
      </div>
      {withReplay.length === 0 ? <EmptyState icon="Clapperboard" title="No replays yet" text="Replays appear here after your live classes." /> : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {withReplay.map((s, i) => (
            <motion.div key={s.id} initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}
              onClick={() => navigate(`/app/session/${s.id}`)} data-testid={`replay-card-${s.id}`}
              className="cursor-pointer overflow-hidden rounded-3xl bg-white shadow-sm border border-black/5 card-pop">
              <div className="relative flex aspect-video items-center justify-center gradient-purple">
                <Icons.PlayCircle size={48} className="text-white" />
                <span className={`absolute right-2 top-2 rounded-full px-2 py-0.5 text-[10px] font-bold ${
                  s.my_replay_status === "completed" ? "bg-green-400 text-white" :
                  s.my_replay_status === "started" ? "bg-yellow-400 text-white" : "bg-white/90 text-csh-grey"}`}>
                  {s.my_replay_status === "completed" ? "🟢 Watched" : s.my_replay_status === "started" ? "🟡 Started" : "🔴 New"}
                </span>
              </div>
              <div className="p-4">
                <div className="text-xs font-bold uppercase text-muted-foreground">Week {s.week_number}</div>
                <h3 className="font-head text-lg text-csh-blue">{s.title}</h3>
                <p className="text-xs text-muted-foreground">{s.date}</p>
              </div>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
}
